module.exports = __webpack_public_path__ + "static/img/huiseyuangou.e727137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/huiseyuangou.png
// module id = OqNw
// module chunks = 3